export var Endpoint;

(function (Endpoint) {
  Endpoint["Production"] = "https://2mjbb0yo1c.execute-api.us-east-1.amazonaws.com/prod/report";
  Endpoint["Test"] = "https://z0on823zcg.execute-api.us-east-1.amazonaws.com/test/report";
})(Endpoint || (Endpoint = {}));

export var report = function report(body, endpoint) {
  if (navigator.sendBeacon) {
    navigator.sendBeacon(endpoint, body);
  } else {
    fetch(endpoint, {
      body: body,
      method: 'POST',
      keepalive: true
    });
  }
};